import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function spinner({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 200 200"
      width="200"
      height="200"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M100 175c41.421 0 75-33.579 75-75s-33.579-75-75-75-75 33.579-75 75 33.579 75 75 75zm0 25c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z"
        clipRule="evenodd"
      ></path>
      <defs>
        <radialGradient
          id="paint0_angular_216_1328"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(90 0 100) scale(100)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="black"></stop>
          <stop offset="1" stopColor="black" stopOpacity="0"></stop>
        </radialGradient>
      </defs>
    </svg>
  );
}

export default spinner;
